import { SET_REPORTS_LIST, SET_REPORTS_LOADING, SET_REPORTS_PARAMS } from "./types";
import { api } from "../App";


export const getReportsList = () => async (dispatch) => {
  dispatch({ type: SET_REPORTS_LOADING, payload: true });
  try {
    const { data } = await api.get(`/reports`);
    dispatch({ type: SET_REPORTS_LIST, payload: data });
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_REPORTS_LOADING, payload: false });
  }
};

export const getReportParams = (reportId) => async (dispatch) => {
  dispatch({ type: SET_REPORTS_LOADING, payload: true });
  try {
    const { data } = await api.get(`/reports/${reportId}`);
    dispatch({ type: SET_REPORTS_PARAMS, payload: data[0] });
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_REPORTS_LOADING, payload: false });
  }
};
export const getReportParamsOptions = (reportId, name) => async (dispatch) => {
  dispatch({ type: SET_REPORTS_LOADING, payload: true });
  try {
    const { data } = await api.get(`/reports/${reportId}/options/${name}`);
    dispatch({ type: SET_REPORTS_PARAMS, payload: data });
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_REPORTS_LOADING, payload: false });
  }
};

export const getReport = (data) => async (dispatch) => {
  let reportLink = ""
  dispatch({ type: SET_REPORTS_LOADING, payload: true });
  try {
    const { data: responseData } = await api.post(`/create_report`, data);
    reportLink = responseData;
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_REPORTS_LOADING, payload: false });
    return reportLink;
  }
};
